/**
 * Eye-Able position fix when user is logged in.
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const eyeAblePositionFix_once = once('eye-able-position-fix', 'body', context);

    $(eyeAblePositionFix_once).each(function() {
      let $body = $(this);

      let eyeAblePositionFixInterval = setInterval(function () {
        if ($('#eyeAble_container_ID').length) {
          let rightValue = 30;
          let topValue = 4;
          if ($body.hasClass('user-logged-in')) {
            rightValue = 60;
            topValue = 10;
          }

          let sheet = new CSSStyleSheet;
          sheet.replaceSync('#eyeAble_columID { right: ' + rightValue + 'px; top: ' + topValue + '% !important; }');
          const host = document.querySelector("#eyeAble_container_ID");
          host.shadowRoot.adoptedStyleSheets.push(sheet);

          let sheet2 = new CSSStyleSheet;
          sheet.replaceSync('.eyeAble_topFixedPosition { right: ' + rightValue + 'px; top: ' + topValue + '% !important; }');
          const host2 = document.querySelector("#eyeAble_container_ID");
          host.shadowRoot.adoptedStyleSheets.push(sheet);

          clearInterval(eyeAblePositionFixInterval);
        }
      }, 400);
    });
  },
}
